import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const FullScreenErrorElement = () => {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    children: /*#__PURE__*/_jsx(Text, {
      as: "p",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "errorBoundary.fullScreenError.title"
      })
    })
  });
};